<template>
  <div style="width:100%;float:left;">
    <CWidgetDropdown color="gradient-warning" :header="'' + data.length" text="Waiting On Cust">
      <template #footer>
        <CCardFooter class="card-footer px-3 py-2 mt-2">
          <CLink
            class="font-weight-bold font-xs btn-block text-warning"
            color="info"
            @click="viewOrders()"
          >
            View Orders
            <CIcon name="cil-arrowRight" class="float-right" width="16"/>
          </CLink>
        </CCardFooter>
      </template>
    </CWidgetDropdown>
    <CModal
      title="Open Orders"
      :show.sync="viewModal"
      size="lg"
    >
      <div style="width:100%;float:left;" v-if="viewModal">
        <h4 style="width:100%;float:left;text-align:center;font-size:13px;">Click to go to order.</h4>
        <!-- <table class="table" v-if="data">
          <thead>
            <tr>
              <th v-if="$store.state.user.user_type === 'csr'">Rep</th>
              <th>Log#</th>
              <th>Cust</th>
              <th>PO</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="val in data" @click="goToOrder(val)">
              <td v-if="$store.state.user.user_type === 'csr'">{{val.order.rep.name}}</td>
              <td>{{val.as400_log_number}}</td>
              <td>{{val.order.customer_info.customer_name}}</td>
              <td>{{val.order.po_number}}</td>
              <td>{{val.local_created_at}}</td>
            </tr>
          </tbody>
        </table> -->
        <div style="width:100%;float:left;">
          <CDataTable
            :items="data"
            :fields="fields"
            column-filter
            table-filter
            v-if="data && fields"
            @row-clicked="rowClicked"
          >
          <template #log="{item}">
            <td>
              {{item.as400_log_number}}
            </td>
          </template>
          <template #rep="{item}">
            <td>
              {{item.rep}}
            </td>
          </template>
          <template #cust="{item}">
            <td>
              {{item.customer_name}}
            </td>
          </template>
          <template #status="{item}">
            <td>
              {{item.as400_status}}
            </td>
          </template>
          <template #date="{item}">
            <td>
              {{item.local_created_at}}
            </td>
          </template>
          <!-- <template #delete="{item}">
            <td>
              <CButton size="sm" v-if="you!=item.id" color="danger" @click="deleteUser( item.id )">Delete</CButton>
            </td>
          </template> -->
        </CDataTable>
      </div>
      </div>
    </CModal>
  </div>
</template>
<script>
var methods = {}

methods.getNewOrders = function () {
  const postData = {
    csr: this.csr,
    customer: this.customer_selected
  }
  axios.post(this.$apiAdress + '/api/orders/getOrdersWaitingOnCustomer?token=' + localStorage.getItem('api_token'), postData).then(res => {
    console.log(res)
    // this.data = res.data
    var arr = []
    res.data.forEach(function (val) {
      var o = {
        color_coding: val.color_coding,
        as400_log_number: val.as400_log_number,
        rep: val.order.rep.name,
        csr_assigned: val.csr_assigned ? val.csr_assigned.name : '',
        customer_name: val.order.customer_info.customer_name,
        as400_status: val.as400_status,
        local_created_at: val.local_created_at,
        order_id: val.order_id,
        order_group_id: val.order_group_id
      }
      arr.push(o)
    })
    this.data = arr
    this.$emit('set', 'orders_waiting_on_customer')
  }).catch(e => {
    console.log(e)
  })
}

methods.goToOrder = function (val) {
  this.$router.push('/order/' + val.order_id + '/' + val.order_group_id)
}

methods.viewOrders = function () {
  this.viewModal = true
}

methods.rowClicked = function (item, index, column, e) {
  this.$router.push('/order/' + item.order_id + '/' + item.order_group_id)
}

export default {
    // ===Component name
    name: "OrdersWaitingOnCustomerWidget",
    // ===Props passed to component
    props: ['csr', 'customer_selected'],
    // ===Components used by this component
    components: {

    },
    // ====component Data properties
    data(){
        return{
          data: [],
          viewModal: false,
          fields: null
        }
    },
    // ===Code to be executed when Component is mounted
    mounted() {
      this.getNewOrders()
      if (this.$store.state.user.user_type === 'csr') {
        this.fields = [
                {
                  label: 'log',
                  key: 'as400_log_number'
                },
                {
                  label: 'rep',
                  key: 'rep'
                },
                {
                  label: 'cust',
                  key: 'customer_name'
                },
                {
                  label: 'status',
                  key: 'as400_status'
                },
                {
                  label: 'date',
                  key: 'local_created_at'
                }
        ]
      } else {
        // this.fields = ['log', 'csr', 'cust', 'status', 'date']
        this.fields = [
                {
                  label: 'log',
                  key: 'as400_log_number'
                },
                {
                  label: 'cust',
                  key: 'customer_name'
                },
                {
                  label: 'status',
                  key: 'as400_status'
                },
                {
                  label: 'date',
                  key: 'local_created_at'
                }
        ]
      }
    },
    // ===Computed properties for the component
    computed: {},
    // ===Component methods
    methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped></style>
